<template>
  <div class="state-item" :class="{'is-select': isSelect, 'is-hand':hand}">
    <img :src="require(`@/assets/industryChainNew/${data.pic||'company1'}.png`)" class="pic">
    <div class="ml-16">
      <div class="name">{{data.name}}</div>
      <div class="number mt-4">
        <AnimateNumber fontSize="26px" fontWeight="600" :number="data.count" />
      </div>
    </div>
  </div>
</template>

<script>
import AnimateNumber from '@/components/animateNumber'
export default {
  name: 'CompanyClassify',
  components: {
    AnimateNumber
  },
  props: {
    hand: {
      type: Boolean,
      default: false
    },
    isSelect: {
      type: Boolean,
      default: false
    },
    data: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {

    }
  },
  methods: {
  }
}
</script>

<style scoped lang="scss">
.state-item + .state-item {
  margin-left: 16px;
}
.state-item {
  flex: 1;
  display: flex;
  align-items: center;
  background: #f4f6f9;
  padding: 8px 20px;
  border: 1px solid #f4f6f9;
  &.is-hand {
    cursor: pointer;
  }
  &.is-select {
    border: 1px solid #5088ff;
  }
  &.is-hand:hover {
    border: 1px solid #5088ff;
  }
  .name {
    font-size: 1.1428571429rem;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #586474;
  }
}
</style>
